import url from '@/utils/url'

export default {
  methods: {
    async replaceRoute(opts, skipAsyncData = true) {
      let route = url.getRoute(this.$route)
      for (let key in opts) {
        // vue.js have bug in array query properties
        // use coma separated values
        if (Array.isArray(opts[key])) {
          route.query[key] = opts[key].join(',')
        } else if (!opts[key]) {
          route.query[key] = null
        } else {
          route.query[key] = opts[key]
        }
      }
      for (let key in route.query) {
        // be careful with 0
        if (!route.query[key]) {
          delete route.query[key]
        }
      }

      // unset center with properties near the zero
      if (route.query.center) {
        let [lat, lng] = route.query.center.split(',')
        if (+lat < 1 || +lng < 1) {
          delete route.query.center
        }
      }

      this.$store.commit('skipAsyncData', {
        name: this.$route.name,
        value: skipAsyncData,
      })

      // for disable global isReplace handler
      route.isReplace = false
      await this.$router.replace(route, () => {})
    },
    async onRoute(newVal) {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getEndpoint(newVal),
      })
      this.updateTableState()
    },
    updateTableState() {
      this.$sharedServices.store.commit('tableState', {
        id: this.$route.name,
        param: 'meta',
        data: this.items?._meta,
      })
    },
  },
}
